import { RefObject } from 'react';
import { TIMING } from '../constants';

/**
 * Focuses an input element after a delay
 */
export function focusInput(
  inputRef: RefObject<HTMLInputElement | null>,
  delay: number = TIMING.FOCUS_DELAY
) {
  setTimeout(() => {
    inputRef.current?.focus();
  }, delay);
}

/**
 * Focuses an input element and sets cursor position
 */
export function focusInputWithSelection(
  inputRef: RefObject<HTMLInputElement | null>,
  position: number,
  delay: number = TIMING.FOCUS_DELAY
) {
  setTimeout(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.setSelectionRange(position, position);
    }
  }, delay);
}
